// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2of1l","table":"styles_table__25WLO"};